// Grouped controllers for lazy loading
export const controllerGroups = {
    editor: [
        './components/editor_js_controller.js'
    ],
    // Future groups can be added here
    // analytics: ['./components/analytics_controller.js'],
    // admin: ['./admin/dashboard_controller.js', './admin/stats_controller.js']
}

// Get all lazy controllers (for main app to exclude)
export const getAllLazyControllers = () => {
    return Object.values(controllerGroups).flat()
}

// Get controllers for specific group
export const getGroupControllers = (groupName) => {
    return controllerGroups[groupName] || []
}